"use client"

import { COLOR_LABELS } from "~/lib/shopify/constants"
import { useTranslate } from "~/providers/I18nProvider/hooks/useTranslate"

export function ColorTranslation({ tKey }: { tKey: keyof typeof COLOR_LABELS }) {
  const t = useTranslate()

  if (!tKey) {
    return null
  }

  try {
    return t(COLOR_LABELS?.[tKey] ?? tKey)
  } catch (error) {
    return tKey
  }
}
